import React from 'react';
import { Calendar } from 'lucide-react';
import { formatDate } from './dateFormat';

interface ScheduledStartBannerProps {
  startDate: string;
  className?: string;
}

const ScheduledStartBanner: React.FC<ScheduledStartBannerProps> = ({ startDate, className = '' }) => {
  const start = new Date(startDate.slice(0, 10) + 'T00:00:00').getTime();
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  const daysUntilStart = Math.max(0, Math.ceil((start - now.getTime()) / (1000 * 60 * 60 * 24)));

  return (
    <div
      className={`relative rounded-xl px-4 py-3 flex items-center justify-between gap-3 ${className}`}
      style={{
        background: 'linear-gradient(180deg, #eff6ff 0%, #dbeafe 100%)',
        border: '1px solid rgba(14, 165, 233, 0.25)',
      }}
    >
      <span
        aria-hidden
        className="absolute left-0 top-3 bottom-3 w-[2px] rounded-r"
        style={{ background: '#0284c7' }}
      />
      <div className="flex items-center gap-2.5 pl-2">
        <Calendar className="w-4 h-4" style={{ color: '#0369a1' }} aria-hidden />
        <div>
          <div className="text-[10px] font-semibold uppercase tracking-[0.12em]" style={{ color: '#0369a1' }}>
            Campaign starts
          </div>
          <div className="text-[15px] font-semibold tracking-tight text-slate-900">
            {formatDate(startDate)}
          </div>
        </div>
      </div>
      <div className="text-right">
        <div className="text-[18px] font-semibold tabular-nums leading-none" style={{ color: '#075985' }}>
          {daysUntilStart}
        </div>
        <div className="text-[10px] font-medium uppercase tracking-[0.1em] text-slate-500 mt-0.5">
          {daysUntilStart === 1 ? 'day' : 'days'} away
        </div>
      </div>
    </div>
  );
};

export default ScheduledStartBanner;
